import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { AccountOverviewResponse } from '../../dashboard/services/account-overview.service';
import { AB_API_INITIAL_VIEW } from '../constants';
import { ApiClientService } from './api-client.service';
import { DefaultPortfolioService } from './default-portfolio.service';

@Injectable({
  providedIn: 'root'
})
export class InitialViewService extends ApiClientService {
  public accountsOverview = new ReplaySubject<AccountOverviewResponse>();
  public accountsOverviewResponse: AccountOverviewResponse = undefined;
  private isLoading = false;

  constructor(
    http: HttpClient,
    private defaultPortfolioService: DefaultPortfolioService
  ) {
    super(http, AB_API_INITIAL_VIEW);
  }

  clearAccountsOverview() {
    this.accountsOverview.complete();
    this.accountsOverview = new ReplaySubject<AccountOverviewResponse>();
    this.accountsOverviewResponse = undefined;
  }

  getInitialView(): Observable<AccountOverviewResponse> {
    if (this.accountsOverviewResponse) {
      return this.accountsOverview.asObservable();
    }
    if (!this.isLoading && !this.accountsOverviewResponse) {
      this.isLoading = true;
      this.get().subscribe(
        response => {
          this.isLoading = false;
          this.accountsOverview.next(response);
          this.accountsOverviewResponse = response;
          const portfolioId = response?.portfolios?.[0]?.id;
          if (portfolioId) {
            this.defaultPortfolioService.setDefaultPortfolio(portfolioId);
          }
        },
        error => {
          this.isLoading = false;
          this.accountsOverview.next(undefined);
        }
      );
    }

    return this.accountsOverview.asObservable();
  }

  getAccounts(): Observable<AccountOverviewResponse> {
    this.accountsOverview.next(this.accountsOverviewResponse);
    return this.accountsOverview.asObservable();
  }
}
